'use client';

import { Button } from '@stone-payments/jade';
import { useIntl } from 'react-intl';
import { usePreselectVariant } from '../../../hooks/usePreselectVariant';
import { digitalWallets } from '../../types/digitalWallets.types';
import { useApplePayReducedForm } from '../../../hooks/useApplePayReducedForm';
import { DigitalWalletPaymentButton } from '../digitalWallets/digitalWalletsPaymentButton.component';

type CheckoutSubmitButtonProps = {
  selectedDigitalWallet: digitalWallets | null;
  isDigitalWalletValid: boolean;
  isCustomerFormLoading: boolean;
  clickToPaySessionPending: boolean;
  isReducedPix: boolean;
};

export function CheckoutSubmitButton({
  selectedDigitalWallet,
  isDigitalWalletValid,
  isCustomerFormLoading,
  clickToPaySessionPending,
  isReducedPix,
}: CheckoutSubmitButtonProps) {
  const intl = useIntl();
  const { showPaymentDetails } = usePreselectVariant();

  const isApplePayReducedForm = useApplePayReducedForm();

  const needsDigitalWalletFields =
    selectedDigitalWallet &&
    selectedDigitalWallet !== 'clickToPay' &&
    (selectedDigitalWallet !== 'applePay' || isApplePayReducedForm);

  const buttonText = isReducedPix
    ? intl.formatMessage({ id: 'button.action.pay' })
    : intl.formatMessage({ id: 'button.Continue' });

  if (!showPaymentDetails) return null;

  if (needsDigitalWalletFields) {
    return (
      <DigitalWalletPaymentButton
        digitalWallet={selectedDigitalWallet}
        isValidFields={isDigitalWalletValid}
      />
    );
  }

  return (
    <Button
      type="submit"
      form="customer-form"
      size="medium"
      variant="primary-solid"
      className="w-full max-[580px]:w-full max-[580px]:mb-jade-300"
      loading={isCustomerFormLoading}
      disabled={clickToPaySessionPending}
    >
      {buttonText}
    </Button>
  );
}
